export default __webpack_public_path__ + "static/media/sign.e51185ce.png";